import { Link } from 'react-router-dom';

export const RestartPage = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white dark:bg-gray-900 px-4 space-y-8">
      <div className="w-full max-w-2xl bg-white dark:bg-gray-800 rounded-xl overflow-hidden">
        <div className="p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 bg-yellow-400 rounded-full flex items-center justify-center">
              <img
                src="https://app.thenewscc.com.br/square_logo_favicon.png"
                alt="Coffee Cup"
                className="rounded-full"
              />
            </div>
            <div className="flex-1">
              <div className="flex items-center justify-between">
                <span className="font-medium text-gray-800 dark:text-gray-200">the news</span>
                <span className="text-sm text-gray-500">sexta-feira, 28 de março de 2025.</span>
              </div>
              <div className="text-sm text-gray-500">06:06</div>
            </div>
          </div>

          <div className="space-y-6">
            <div className="text-left space-y-2">
              <h1 className="text-3xl font-bold mb-6">
                <span >Campanha 2X</span>
              </h1>

              <div className=" space-y-8">
                <div>
                  <h2 className="text-xl font-bold  mb-4">
                    ⏰ Últimos Momentos para Dobrar suas Indicações!
                  </h2>
                  <p className="text-gray-700 dark:text-gray-300">
                    Faltam apenas algumas horas, e suas indicações ainda valem em dobro! Cada amigo que você traz para o the news conta como dois pontos na sua jornada para conquistar os prêmios exclusivos.
                  </p>
                </div>

                <div className="border-t  pt-8">
                  <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-3">
                    🎁 Renovação dos Brindes
                  </h3>
                  <p className="text-gray-700 dark:text-gray-300 mb-6">
                    Na próxima semana, o programa passará por uma renovação completa dos brindes. Isso significa que alguns dos prêmios atuais não estarão mais disponíveis depois disso.
                  </p>

                  <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-3">
                    💫 Presente Especial
                  </h3>
                  <p className="text-gray-700 dark:text-gray-300">
                    Como presente especial nesta última semana: todas as indicações valem em dobro! Não deixe essa oportunidade única passar.
                  </p>
                </div>

                <div className="flex flex-col items-center space-y-4 pt-8 border-t">
                  <p className="text-sm text-gray-600 dark:text-gray-400 text-center italic mb-6">
                    *Os pontos não aparecerão duplicados na plataforma de contabilização. A contagem será ajustada por nossa equipe durante o final de semana.
                  </p>
                </div>
              </div>

              <div className="flex justify-between items-center pt-6 border-t border-gray-200 dark:border-gray-700 mt-8">
                <Link
                  to="/"
                  className="text-yellow-400 hover:text-yellow-500 transition-colors"
                >
                  ← voltar
                </Link>
                <span className="text-sm text-gray-500 dark:text-gray-400">
                  Última atualização: {new Date().toLocaleDateString('pt-BR')}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};